export default __webpack_public_path__ + "static/media/girl-up.fc204655.png";